var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: { title: "广告管理", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            },
            close: function($event) {
              return _vm.dataReset()
            }
          }
        },
        [
          _c("div", { staticClass: "popover" }, [
            _c(
              "div",
              { staticClass: "popover-item" },
              [
                _c(
                  "el-table",
                  {
                    ref: "adv_platformTable",
                    attrs: {
                      height: "540",
                      "tooltip-effect": "dark",
                      "highlight-current-row": "",
                      data: _vm.adv_platformtableData,
                      border: "",
                      "show-overflow-tooltip": true
                    },
                    on: {
                      "selection-change": function($event) {
                        return _vm.handleSelectionChange(
                          $event,
                          "adv_platformSelection"
                        )
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", prop: "game_id", width: "50" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "adv_platform_name", label: "广告平台" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "popover-item" },
              [
                _c(
                  "el-table",
                  {
                    ref: "adv_placeTable",
                    attrs: {
                      height: "540",
                      "tooltip-effect": "dark",
                      data: _vm.adv_placetableData,
                      border: "",
                      "show-overflow-tooltip": true
                    },
                    on: {
                      "selection-change": function($event) {
                        return _vm.handleSelectionChange(
                          $event,
                          "adv_placeSelection"
                        )
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", prop: "id", width: "50" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "adv_place_name", label: "广告位置名称" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { round: "" }, on: { click: _vm.dataReset } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }